import { z } from "zod";
const faceCollageEntranceTopBottomSchema = z.object({
    transitionDurationInFrames: z.number().optional(),
    exitDurationInFrames: z.number().optional(),
    topStyle: z.record(z.string(), z.any()).optional(),
    bottomStyle: z.record(z.string(), z.any()).optional(),
});
const faceCollageEntranceMaskSchema = z.object({
    transitionDurationInFrames: z.number().optional(),
    exitDurationInFrames: z.number().optional(),
    maskAssetUrl: z.string(),
});
const faceCollageEntranceSchema = z.discriminatedUnion("variant", [
    faceCollageEntranceTopBottomSchema.extend({
        variant: z.literal("zoom-in"),
    }),
    faceCollageEntranceTopBottomSchema.extend({
        variant: z.literal("squeeze-in"),
    }),
    faceCollageEntranceTopBottomSchema.extend({
        variant: z.literal("slide-in"),
    }),
    faceCollageEntranceTopBottomSchema.extend({
        variant: z.literal("diamond-mask"),
    }),
    faceCollageEntranceTopBottomSchema.extend({
        variant: z.literal("stagger-in"),
    }),
    faceCollageEntranceTopBottomSchema.extend({
        variant: z.literal("random-pop-in"),
    }),
    faceCollageEntranceTopBottomSchema.extend({
        variant: z.literal("fade-in"),
    }),
    faceCollageEntranceMaskSchema.extend({
        variant: z.literal("heart-mask"),
    }),
]);
const commonFaceCollageSchema = z.object({
    colorFilter: z.enum(["grayscale", "luminosity"]).optional(),
    borderShape: z.enum(["circle", "rounded-square", "diamond"]).optional(),
    // width in px
    borderWidth: z.number().optional(),
    startAtSeconds: z.number().optional(),
    faceCollageSceneDurationSeconds: z.number().optional(),
});
export const faceCollageSchema = z.discriminatedUnion("variant", [
    commonFaceCollageSchema.extend({
        variant: z.literal("top-bottom-static"),
        entrance: faceCollageEntranceSchema.optional(),
    }),
    commonFaceCollageSchema.extend({
        variant: z.literal("bottom-static"),
        entrance: faceCollageEntranceSchema.optional(),
    }),
    commonFaceCollageSchema.extend({
        variant: z.literal("hex-grid"),
    }),
    commonFaceCollageSchema.extend({
        variant: z.literal("carousel"),
    }),
    commonFaceCollageSchema.extend({
        variant: z.literal("bubble"),
    }),
    commonFaceCollageSchema.extend({
        variant: z.literal("warp"),
    }),
    commonFaceCollageSchema.extend({
        variant: z.literal("stripes-right-skewed"),
    }),
    commonFaceCollageSchema.extend({
        variant: z.literal("top-bottom-carousel"),
    }),
    commonFaceCollageSchema.extend({
        variant: z.literal("grid-bounce"),
    }),
    commonFaceCollageSchema.extend({
        variant: z.literal("school-spirit"),
    }),
]);
